// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IPackageUpdateCommandParams {
	pu: string | undefined;

	$type?: string | undefined;
}
export class PackageUpdateCommandParams {
	constructor(data?: IPackageUpdateCommandParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	pu: string | undefined;

	static $type: string = "CoreApi.Models.DeviceCommands.PackageUpdateCommandParams, ";
	$type?: string | undefined = PackageUpdateCommandParams.$type;
}

